import React from "react";
import Layout from "../../layouts/Layout";

import apiService from '../../utils/api.service';
import moment from "moment";
import Lineliff from '../../components/LineLiff';
import { connect } from "react-redux";
import actions from "../../redux/actions";
import helper from "../../utils/helper"
import { useNavigate, useSearchParams } from "react-router-dom";
import BButton from "../../components/general/BButton";
import TextFieldSC from "../../components/TextFieldSC";
import DesktopDatePickerSC from "../../components/DesktopDatePickerSC";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import StatusHopital from './StatusHopital'
import { MonthPicker } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ShiftStatus from './ShiftStatus'
import BackPage from '../../components/icons/BackPage'
import _ from 'lodash'
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/th';

class HistoryCheckIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectDate: moment(),
      checkInData: []
    };
    this.gotoCheckIn = this.gotoCheckIn.bind(this)
  }
  componentDidMount(){
    this.LoadHistoryCheckIn()
  }

  cbLineLiff (e) {
    // const payload = { memberId: e.memberId, month: moment(this.state.currentDate).format('MM'), year: moment(this.state.currentDate).format('YYYY') }
    // this.setState({ memberId: e.memberId },() => { this.LoadHistoryCheckIn(payload) })
  }

  async LoadHistoryCheckIn() {
    try {
      const { selectDate } = this.state
      const _selectDate = selectDate.$d || selectDate
      console.log('LoadHistoryCheckIn selectDate >>', selectDate.$d)
      const M = moment(_selectDate).format('M') 
      const YYYY = moment(_selectDate).format('YYYY') 
      const payload = { memberId: this.props?.user?.lineId?.memberId, month: M, year: YYYY }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CheckIn.SearchTimeRecordHistories(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        this.setState({ checkInData: data })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  gotoCheckIn(){
    this.props.navigate('/check-in')
  }

  render() {
    const test = 2
    const { selectDate, checkInData } = this.state
    const isCKToday = (item = '', isWorkout) => {
      console.log('item.shiftTimeFrom >>', item.shiftTimeFrom)
      console.log('item.shiftTimeTo >>', item.shiftTimeTo)
      let isNow = moment(item.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
      const isNextDay = moment(item.shiftTimeTo, 'HH:mm:ss').diff(moment(item.shiftTimeFrom, 'HH:mm:ss'), 'minute') <= 0
      if(isNow === false && isNextDay ) {
        isNow = moment(item.date).format('YYYY-MM-DD') === moment().add(-1, 'day').format('YYYY-MM-DD')
      }
      console.log('isNextDay >>', isNextDay)
      console.log('isNow >>', isNow)
      console.log('----------------------------')
      return isNow
    }
    const workINOUT = (worktime, isWorkout = false, isToday = false ) => { 
      console.log('worktime >>', worktime)
      console.log('isWorkout >>', isWorkout)
      console.log('isToday >>', isToday)
      if (worktime) {
        return `${helper.FN.toTimeHM(worktime)} น.`
      }

      if(isWorkout && isToday) {
        return `Now`
      }
      
      return '..........'
    }
    return (
      <Layout>
        <LocalizationProvider dateAdapter={AdapterDayjs}  adapterLocale={'th'}>
          <div className="container-checkin">
            <div className="header hasback">
              <div className="backpage" onClick={this.gotoCheckIn}><BackPage/></div>
              <div className="main-header-text">ประวัติการเข้า - ออก</div>
            </div>
            {/* <MonthPicker/> */}
            <main className="container-history">
              <div className="select-month">
                <div>
                  <DesktopDatePickerSC
                    views={['month', 'year']}
                    minDate={'2022-11-01'}
                    maxDate={moment().add(10,'year').format('YYYY-MM-DD')}
                    value={selectDate}
                    onChange={(newValue) => {
                      console.log('newValue >>', newValue)
                      this.setState({ selectDate: newValue },()=> this.LoadHistoryCheckIn());
                    }}
                    renderInput={(params) => {
                      return <TextFieldSC {...params}  variant="standard" fullWidth helperText={null} />
                    }}
                  />
                </div>
              </div>
              { 
                checkInData.map((item,index) => {
                  return  <div className="list-history">
                    <div className="L">
                      <h4>{helper.FN.toDateFullThai(item.date)} ({helper.FN.numberToshift(item.shift)})</h4>
                      <ShiftStatus statusList={item.status}/>
                      <div className="h-ward">
                        <StatusHopital/>
                        <h5>{item.ward?.hospital?.hospitalName} : {item.wardName}</h5>
                      </div>
                    </div>
                    <div className="R">
                      <div className="checkin-time">{workINOUT(item.workIn)} - {workINOUT(item.workOut, true, isCKToday(item))}</div>
                    </div>
                  </div>
                })
              }
            </main>
          </div>
        </LocalizationProvider>
      </Layout>
    );
  }
}


function CheckInRoute(props) {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return <HistoryCheckIn navigate={navigate} searchParams={searchParams} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(CheckInRoute);